import { createSelector } from '@reduxjs/toolkit';
import { parseUsers } from 'src/app/helpers/userSelect';
export const selectAmbassadorsForFormField = createSelector([(state) => state.usersMessaging.ambassadors], (ambassadors) => parseUsers(ambassadors));
export const selectIsUsersMessagingLoading = (state) => state.usersMessaging.isLoading;
